import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { login, logout } from "features/auth/usecases/AuthUsecases";
import { DateTime } from "luxon";


export const loginThunk = createAsyncThunk(
  "auth/login",
  async (data, thunkAPI) => {
    try {
      const response = await login({
        id: data.id,
        password: data.password,
      });

      const user = response;

      // Check role here
      // if (user?.classificationName !== "노상근무자") {
      //   return thunkAPI.rejectWithValue("권한이 없습니다"); // "You don't have permission"
      // }

      if (!user?.userId) {
        if (user?.result == 'FAIL') {
          return thunkAPI.rejectWithValue("FAIL"); // "You don't have permission"
        } else if (user?.result == 'PARKING_LOT_MISMATCH') {
          return thunkAPI.rejectWithValue("PARKING_LOT_MISMATCH"); 
        } else {
          return thunkAPI.rejectWithValue("ALREADY_LOGIN");
        }
      }

      return user;
    } catch (error) {
      console.error("Login error:", error);
      return thunkAPI.rejectWithValue("Login failed");
    }
  }
);


export const logoutThunk = createAsyncThunk(
  "auth/logout",
  async (data, thunkAPI) => {
    try {
      const response = await logout({
        id: data.id,
        parkingId: data.parkingId,
      });

      const user = response;
      return user;
    } catch (error) {
      console.error("Logout error:", error);
      return thunkAPI.rejectWithValue("Logout failed");
    }
  }
);


export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: {},
    status: "idle",
    serverTime: DateTime.now().setZone('Asia/Seoul'), // Default server time
    dayType: "WEEKDAY", // or "HOLIDAY"
    logedIn: false,
    pasIp: '172.28.219.59',
    pasPort: '8021'
  },
  reducers: {
    setServerTime: (state, action) => {
      state.serverTime = action.payload;
    },
    setLogedIn: (state, action) => {
      state.logedIn = action.payload;
    },
    setToken: (state, action) => {
      state.user.accessToken = action.payload.accessToken;
      state.user.refreshToken = action.payload.refreshToken;
    },
    updateAccessToken: (state, action) => {
      if (state.user) {
        state.user.accessToken = action.payload; // Update only the Access Token
      }
    },
    setPasPort: (state, action) => {
      state.pasPort = action.payload;
    },
    setDayType: (state, action) => {
      state.dayType = action.payload; // Update the day type
    },
    setUser: (state, action) => {
      state.user = action.payload; // Update the user object
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        //console.log("action.payload", action);
        const isSuccess = action?.payload !== null;

        const user = {
          ...action.payload,
          success: isSuccess,
          parkingId: action?.payload?.parking.parkingId ?? "03-002",
          pasServer: action?.payload?.pasServer ?? "http://localhost:8022/v2/",
        };
        state.user = user;
        state.status = "success";
        localStorage.setItem("pasServer", user?.pasServer);
        // api.defaults.baseURL = user.pasServer;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(logoutThunk.fulfilled, (state) => {
        state.user = null;
        localStorage.clear();
        state.status = "idle";
      });
  },
});

export const { setServerTime, setLogedIn, setToken, updateAccessToken, setPasPort, setDayType, setUser } = authSlice.actions;
export default authSlice.reducer;
